import { type RefObject } from 'react';
import { useScrollToTopFixIOS } from '@hungryroot/environment';
import { tagGroups } from '@hungryroot/tags';
import { ControlTagBinaryRating } from '../../components/ControlTagBinaryRating/ControlTagBinaryRating';
import { QuizQuestionScreen } from '../../components/QuizQuestionScreen/QuizQuestionScreen';
import { SectionLabel } from '../../components/SectionLabel/SectionLabel';
import { ToggleFour } from '../../components/Toggle/ToggleFour/ToggleFour';
import { useFilteredQuizTags } from '../../main';

interface Props {
  testid: string;
  scrollRef: RefObject<HTMLDivElement>;
}

export function Cuisines(props: Props) {
  const { testid, scrollRef } = props;

  useScrollToTopFixIOS(scrollRef);

  const { getDisplayTagsFilter } = useFilteredQuizTags();

  return (
    <QuizQuestionScreen
      testid={testid}
      heroText="What cuisines do you like?"
      subCopy="Feeling so-so? Skip those."
      sectionLabel={<SectionLabel label="Your tastes" />}
    >
      <ControlTagBinaryRating
        testid={testid}
        tagGroupId={tagGroups.cuisine}
        question="cuisines"
        layoutVariant="two-column"
        filter={getDisplayTagsFilter('cuisine')}
      >
        {({ tag, likeDislike, index }) => {
          const { id: tagId, name: tagName, image_url: imgSrc } = tag;
          const tagCyid = `${testid}-toggle-tag-${tagId}`;

          return (
            <ToggleFour
              key={tagId}
              testid={tagCyid}
              tagId={tagId}
              tagName={tagName}
              likeDislike={likeDislike}
              imgSrc={imgSrc}
              style={{ animationDelay: `${0.05 * index + 0.5}s` }}
            />
          );
        }}
      </ControlTagBinaryRating>
    </QuizQuestionScreen>
  );
}
